var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCartoComponentsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#162945",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.635 32C74.452 32 81.6 24.837 81.6 16S74.452 0 65.635 0C56.817 0 49.67 7.163 49.67 16s7.147 16 15.965 16z",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.546 21.317c2.23 0 3.52-.977 4.475-2.303l-2.114-1.516c-.609.743-1.231 1.239-2.289 1.239C4.2 18.737 3.2 17.54 3.2 16.01v-.03c0-1.486.999-2.711 2.418-2.711.97 0 1.637.481 2.216 1.195l2.115-1.647c-.898-1.239-2.23-2.114-4.302-2.114-3.07 0-5.33 2.333-5.33 5.307v.029c0 3.047 2.332 5.277 5.229 5.277zm9.295-.204h2.94l.724-1.837h3.925l.724 1.837h3.012L21.85 10.836h-2.708l-4.301 10.277zm4.49-4.038l1.144-2.887 1.13 2.887H19.33zm12.306 4.038h2.81v-3.09h1.246l2.042 3.09h3.23l-2.42-3.557c1.261-.54 2.086-1.574 2.086-3.149v-.029c0-1.006-.304-1.779-.897-2.376-.681-.685-1.753-1.094-3.303-1.094h-4.794v10.205zm2.81-5.306v-2.464h1.854c.927 0 1.52.408 1.52 1.224v.03c0 .743-.564 1.21-1.505 1.21h-1.869zm31.188-5.14A5.328 5.328 0 0170.957 16a5.328 5.328 0 01-5.322 5.333A5.328 5.328 0 0160.313 16a5.328 5.328 0 015.322-5.333zm-10.77.241v2.479h-3.042v7.726h-2.81v-7.726h-3.026v-2.479h8.878z"
  }))));
}

export default __webpack_public_path__ + "2a05c86ee4d6b5f6325016f1091fee17.svg";
export { SvgCartoComponentsLogo as ReactComponent };